import React from 'react';
import '../App.css';

interface LoaderProps {
  text?: string;
}

const Loader: React.FC<LoaderProps> = ({ text }) => (
  <div className="loading-container">
    <div className="bonds-loader-flex">
      <i className="fas fa-spinner fa-spin loader-icon" aria-label="Loading" />
      {text && <span className="loader-text">{text}</span>}
    </div>
  </div>
);

export default Loader; 